export default "__VITE_ASSET__CuIAPogC__"